import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { Observable } from "rxjs";
import { constants } from "../constants";

@Injectable({ providedIn: 'root' })
export class CpaService {

    constructor(private http: HttpClient) { }

    getAccounts(cpa: string): Observable<string[]> {
        return this.http.get<string[]>(`${constants.BASE_URL}/cpa/accounts/${cpa}`);
    }

}